<template>
  <div class="sdiv dinline-block vtop cpointer fs14 tleft" v-on:click="goDetail(item.id)">
    <div class="igs ofhidden">
      <img class="trans3" :src="item.image" width="300" height="200" />
    </div>
    <div class="nm mt20 mb15 fs16 lh10 ofhidden">{{item.title}}</div>
    <div class="tc12 pl25">{{item.release_time}}</div>
  </div>
</template>

<script>
export default {
  name: "news-item",
  props:[
    'item',
    'index',
  ],
  methods:{
    goDetail (id){

      let path = `/news/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')

      //this.$router.push({path:'/news/detail',query:{id:id}})
    }
  }
}
</script>

<style scoped>
  .index-wrap .newsdiv .sdiv:hover img{transform: scale(1.05);}
  .index-wrap .newsdiv .sdiv{margin: 0 12px 25px;width: 300px;*width: 290px;width: 290px;}
  .index-wrap .newsdiv .sdiv:nth-child(4n){margin-right: 0;}
  .index-wrap .newsdiv .sdiv:nth-child(4n + 1){margin-left: 0;}
  .index-wrap .newsdiv .nm{height: 16px;}
  .index-wrap .newsdivs{width: 300px;height: 200px;}
  .index-wrap .newsdiv .border:hover{box-shadow: 0 0 15px #ccc;}
  .index-wrap .newsdiv .border:hover .nm{color: #316f3e;}
  .index-wrap .newsdiv .border{margin: 0 10px 20px;width: 410px;height: 160px;}
  .index-wrap .newsdiv .border:nth-of-type(5){margin-left: 0;}
  .index-wrap .newsdiv .border:nth-of-type(7){margin-right: 0;}
  .index-wrap .newsdiv .txt{padding: 25px 10px 0 70px;}
  .index-wrap .newsdiv .dt{left: 0;top: 20px;width: 70px;}
  .index-wrap .newsdiv .int{height: 80px;}
</style>



// WEBPACK FOOTER //
// src/components/index/news-item.vue